<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
            class="input form-control"
            @keypress.enter="find()"
            v-model="query.generic"
            placeholder="Pesquisar por Chave"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
      
      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
      
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterStartDate, filterEndDate]"/>
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="event-important">Sucesso?</label>
          <select v-model="query.success" id="event-important" class="form-control">
            <option v-for="opt in filterSuccess.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <label>Tipo do documento</label>
          <Select2 :options="filterType" v-model="query.type"/>
        </div>
        
        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>
        
        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      
      </div>
    </template>
    <hr>

    <!-- Buttons -->
    <div class="row mt-2">
      <div class="col-md-12">
        <router-link tag="button"
                     to="/table/layouts/new"
                     class="btn btn-primary mt-1 mr-1"
        >
          Novo
        </router-link>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Público</th>
              <th>Criado por</th>
              <th>Criado em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="table in tables" :key="table.id">
              <td>{{ table.name }}</td>
              <td>
                <span class="truncate-0">{{ table.description }}</span>
              </td>
              <td>{{ table.public ? 'Sim' : 'Não' }}</td>
              <td>{{ table.createdBy }}</td>
              <td>{{ table.createdAt | datetime }}</td>
              <td>
                <router-link :to="`/custom_table/tables/${table.id}`" tag="a" class="btn btn-outline">
                  Detalhes
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'

export default {
  components: { BadgeFilters, ChevronDownIcon, Pagination, SearchIcon },
  computed: {
    tables() {
      return this.getModels || []
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    modelPathPrefix: 'custom_table',
    nameModel: 'Table',
  }),
  methods: {
    find() {
      this.asyncTemplateSelect()
    },
  },
  mixins: [ModelMapper],
  name: 'Index'
}
</script>

<style scoped>

</style>